import { createAction } from 'redux-act';

import Layout from '../../../models/interfaces/layout/Layout';
import MergedTable from '../../../models/interfaces/layout/MergedTable';
import Table from '../../../models/interfaces/layout/Table';
import TableType from '../../../models/interfaces/layout/TableType';
import FetchPayload from '../FetchPayload';
import TimestampPayload from '../TimestampPayload';

export interface FetchLayoutsPayload extends FetchPayload {
  placeUuid: string;
}
export const fetchLayouts = createAction<FetchLayoutsPayload>('FETCH_LAYOUTS');

export interface LayoutsFetchedPayload extends TimestampPayload {
  placeUuid: string;
  layouts: Layout[];
  mergedTables: MergedTable[];
  tables: Table[];
  tableTypes: TableType[];
}
export const layoutsFetched = createAction<LayoutsFetchedPayload>('LAYOUTS_FETCHED');

export interface LayoutsFetchFailedPayload extends TimestampPayload {
  placeUuid: string;
}
export const layoutsFetchFailed = createAction<LayoutsFetchFailedPayload>('LAYOUTS_FETCH_FAILED');
export type FetchLayoutsResponsePayload = LayoutsFetchedPayload | LayoutsFetchFailedPayload;
